import React from 'react';
import parse from 'html-react-parser';
import './vin-information.scss';
import { useOSBContentFragment } from '../../../../../hooks/owners-osb/aem-content-util/use-osb-content-fragment';
import vinNumberWindowVehicle from '../../../../../assets/osb-v3/icons-vin-number-window-vehicle.svg';
import vinNumberDocumentation from '../../../../../assets/osb-v3/icons-vin-number-documentation.svg';
import vinNumberWindowVehicleFront from '../../../../../assets/osb-v3/icons-vin-number-window-vehicle-front.svg';
import regPlateNumber from '../../../../../assets/osb-v3/icons-reg-plate-number.svg';

const VinInformation = () => {
    const vehicleStepContent =
        useOSBContentFragment('common/osb-v3', 'vehicle-step') || {};
    const vinLocations = [
        {
            icon: vinNumberWindowVehicle,
            alt: "Driver's side doorframe",
            description:
                vehicleStepContent?.modalDriversSideDoorframeDescription || '',
        },
        {
            icon: vinNumberWindowVehicleFront,
            alt: 'VIN visible through windshield',
            description:
                vehicleStepContent?.modalVisibleThroughWindshieldDescription ||
                '',
        },
        {
            icon: vinNumberDocumentation,
            alt: 'Vehicle registration or insurance documents',
            description:
                vehicleStepContent?.modalYourVehicleDocumentationDescription ||
                '',
        },
    ];

    return (
        <div className="vin-reg-info-container">
            {/* VIN Section */}
            <div className="vin-section" data-testid="vin-section">
                <div className="section-header">
                    <h2 className="section-title" data-testid="vin-title">
                        {vehicleStepContent?.modalFindYourVinTitle?.toString()}
                    </h2>
                    <span className="section-example" data-testid="vin-example">
                        {vehicleStepContent?.findYourVinPlaceholder?.toString()}
                    </span>
                </div>
                <p
                    className="section-description"
                    data-testid="vin-description"
                >
                    {vehicleStepContent?.modalFindYourVinSubtitle}
                </p>
                <div
                    className="vin-locations-grid"
                    data-testid="vin-locations-grid"
                >
                    {vinLocations.map((location, index) => (
                        <div
                            className="location-item"
                            key={location.alt}
                            data-testid={`vin-location-${index}`}
                        >
                            <img
                                src={location.icon}
                                alt={location.alt}
                                className="location-icon"
                            />
                            <div className="location-text">
                                {parse(location.description.toString())}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Divider */}
            <hr className="modal-divider" />

            {/* Registration Number Section */}
            <div className="reg-section" data-testid="reg-section">
                <div className="section-header">
                    <h2 className="section-title" data-testid="reg-title">
                        {vehicleStepContent?.modalFindYourRegistrationNumberLabel?.toString()}
                    </h2>
                    <span className="section-example" data-testid="reg-example">
                        {vehicleStepContent?.findYourRegistrationPlaceholder?.toString()}
                    </span>
                </div>
                <div className="reg-content" data-testid="reg-content">
                    <img
                        src={regPlateNumber}
                        alt="Vehicle registration plate"
                        className="location-icon"
                    />
                    <div className="location-text">
                        {parse(
                            (
                                vehicleStepContent?.modalRegistrationNumberDescription ||
                                ''
                            ).toString()
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VinInformation;
